var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"tipo-ata","rota-base":"/admin/tipo-ata","titulo":"TIPOS DE ATA","titulo-singular":"Tipo de Ata","colunas-extras":[]}})
}
var staticRenderFns = []

export { render, staticRenderFns }